const AUTH_BODY_CLASSES = [
    'header-fixed',
    'header-tablet-and-mobile-fixed',
    'aside-enabled',
    'aside-fixed',
];

const AUTH_SHELL_ROOT_IDS = ['kt_header', 'kt_aside'];

export function applyAuthenticatedBodyShell() {
    AUTH_BODY_CLASSES.forEach((className) => {
        document.body.classList.add(className);
    });
}

export function clearAuthenticatedBodyShell() {
    AUTH_BODY_CLASSES.forEach((className) => {
        document.body.classList.remove(className);
    });

    AUTH_SHELL_ROOT_IDS.forEach((id) => {
        document.querySelectorAll(`#${id}`).forEach((element) => {
            element.remove();
        });
    });

    document.querySelectorAll('.drawer-overlay').forEach((element) => {
        element.remove();
    });

    document.querySelectorAll('body > .menu-sub-dropdown').forEach((element) => {
        element.remove();
    });
}
